import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconClipboard"><Path fillRule="evenodd" clipRule="evenodd" d="M8.10352 4C8.42998 2.84575 9.49122 2 10.75 2H13.25C14.5088 2 15.57 2.84575 15.8965 4H17.25C18.7688 4 20 5.23122 20 6.75V19.25C20 20.7688 18.7688 22 17.25 22H6.75C5.23122 22 4 20.7688 4 19.25V6.75C4 5.23122 5.23122 4 6.75 4H8.10352ZM9.5 4.75V6.25C9.5 6.38807 9.61193 6.5 9.75 6.5H14.25C14.3881 6.5 14.5 6.38807 14.5 6.25V4.75C14.5 4.05964 13.9404 3.5 13.25 3.5H10.75C10.0596 3.5 9.5 4.05964 9.5 4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard;
